import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRightArrowLeft } from '@fortawesome/pro-solid-svg-icons';

import Svg from '@svg/index';
import { Flex } from '@ui-library/flex';
import { FlexCard } from '@ui-library/card';

interface McpAuthorizationCardProps {
  content: React.ReactNode;
  actions: React.ReactNode;
}

export const McpAuthorizationCard: React.FC<McpAuthorizationCardProps> = ({ content, actions }) => (
  <Flex style={{ minHeight: '100vh' }} justifyContent="center" alignItems="center">
    <FlexCard
      gap="1rem"
      style={{ maxWidth: '500px', height: '400px' }}
      flexDirection="column"
      justifyContent="space-between"
    >
      <Flex alignItems="center" alignSelf="center" gap="1rem">
        <Svg
          style={{ borderRadius: '5px' }}
          name="icon-placeholder"
          aria-label="Placeholder"
          size={48}
        />
        <FontAwesomeIcon icon={faArrowRightArrowLeft} size="1x" />
        <Svg name="new-mobile-logo" aria-label="RudderStack logo" size={48} />
      </Flex>
      {content}
      <Flex justifyContent="flex-end" gap="12px">
        {actions}
      </Flex>
    </FlexCard>
  </Flex>
);
